// @flow

import { connect } from 'react-redux';
import ThemeProviderComponent from './ThemeProvider';
import { themeNameSelector } from '../../../modules/Theme/selectors';

const mapStateToProps = state => ({
  themeName: themeNameSelector(state),
});

export default connect(mapStateToProps)(ThemeProviderComponent);
